import { SocketEvent } from "@iventis/types/loading.types";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ResourceTypes, SocketStatus, wsSend, ConnectionState } from "@iventis/api/src/connection.slice";

export type Resource = {
    resourceId: string;
    sourceId: string;
    resourceType: ResourceTypes;
};

/**
 * Call this hook in functional components which open a resource/s on mount and close a resource/s when unmounting
 * @param {Resource[]} resources - an array of resources that will open/close when mounting/unmounting component
 */
export const useResourceConnection = (initialResources: Resource[] = []): ((newResources: Resource[]) => void) => {
    const { connectionStatus } = useSelector((s: { connectionReducer: ConnectionState }) => s.connectionReducer);

    const dispatch = useDispatch();

    const [resources, setResources] = useState<Resource[]>(initialResources);

    useEffect(() => {
        if (connectionStatus === SocketStatus.OPENED) {
            resources.forEach(({ resourceId, resourceType, sourceId }) => dispatch(wsSend({ eventName: SocketEvent.RESOURCE_OPENED, resourceId, sourceId, resourceType })));
        }

        return () => {
            if (connectionStatus === SocketStatus.OPENED) {
                resources.forEach(({ resourceId, resourceType, sourceId }) => {
                    dispatch(wsSend({ eventName: SocketEvent.RESOURCE_CLOSED, resourceId, sourceId, resourceType }));
                });
            }
        };
    }, [connectionStatus, resources]);

    return (newResources: Resource[]) => {
        setResources(newResources);
    };
};
